<div>
    <div class="p-b-24 font-c1 text-center">
        Enviá este pack completo como regalo ingresando el número de teléfono de la persona a la que se lo querés regalar.
    </div>
    <div>
        <form class="form-horizontal form-material" [formGroup]="formGroup" (ngSubmit)="onSubmit()" #formDir="ngForm">

            <div class="d-flex-between align-items-center">
                <app-phone-input [formGroup]="formGroup" [country]="sale?.country" [label]="'Teléfono celular'" (change)="onSearchPhone(1)"></app-phone-input>
            </div>

            <!-- Phone without account -->
            <div class="font-c1" *ngIf="customerReceiving == null && !validCustomerReceiving">
                No tiene cuenta en Givi.
            </div>

            <!-- Phone with account -->
            <p class="font-c1" *ngIf="validCustomerReceiving">Este número pertenece: 
                <b *ngIf="customerReceiving?.name.length > 1">{{customerReceiving?.name }} {{customerReceiving?.lastName?.charAt(0)}}</b>
                <b *ngIf="customerReceiving?.name.length  <= 1"> Pendiente de completar perfil </b>
            </p>

            <!-- Button submit -->
            <div class="d-flex-center m-t-10">
                <button *ngIf="!validCustomerReceiving && showBtn == 1" class="btn btn-dark w-100" type="button" 
                [disabled]="formGroup.invalid" (click)="onSearchPhone(2)" style="padding: 8px 40px; text-transform: none; border-radius: 25px;">
                    Buscar
                </button>
                <button *ngIf="validCustomerReceiving && showBtn == 2" class="btn btn-dark w-100" type="submit" 
                [disabled]="formGroup.invalid" style="padding: 8px 40px; text-transform: none; border-radius: 25px;">
                    Enviar
                </button>
                <button *ngIf="customerReceiving == null && !validCustomerReceiving && showBtn == 3" class="btn btn-dark w-100" 
                (click)="onSendLink()" style="padding: 8px 40px; text-transform: none; border-radius: 25px;">
                    Enviar por link
                </button>
            </div>
        </form>
    </div>
</div>


<ng-template #showConfirmationSendGivi let-modal>
    <div class="modal-body">
        <div class="d-flex justify-content-center mt-3">
            <div class="container m-b-24">
                <div class="row" style="background-color: #F5F5F7; padding: 15px; border-radius: 9px;">
                    <div class="col-5">
                        <div class="text-center">
                            <div class="m-t-10">
                                <img [src]="sale.package.imageUrl" width="73px">
                            </div>
                            <span class="font-bold">{{sale.total | currency: sale.package?.currencySymbol : 'symbol': '1.0'}}</span>
                        </div>
                    </div>
                    <div class="col-2" class="text-center d-flex align-items-center" style="padding-top: 5%;">
                        <i class="mdi mdi-chevron-double-right  mdi-36px"></i>
                    </div>
                    <div class="d-flex-center align-items-center" class="col-5">
                        <div class="text-center">
                            <div>
                                <app-img-round [src]="customerReceiving.logoURL" [width]="55"></app-img-round>
                            </div>
                            <div class="m-t-8">
                                <span class="font-bold">
                                    {{customerReceiving.name }} {{customerReceiving.lastName.charAt(0)}}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-center">
            <span class="font-c1" *ngIf="validCustomerReceiving">
                El Pack se va adquirir a 
                <b>{{customerReceiving.name }} {{customerReceiving.lastName.charAt(0)}}</b> 
                y automáticamente se le va a notificar. El Pack va a desaparecer de tu cuenta.
            </span>
        </div>
        <div class="d-flex-center m-t-20">
            <div>
                <button class="btn-dark-custom" (click)="updateTransaction()">Confirmar</button>
                <div class="text-muted d-flex-center pt-2" (click)="closeModal()">Cancelar</div>
            </div> 
        </div>
    </div>
</ng-template>